import React, { useEffect, useState } from 'react';
import { getServicesList } from '../../services/DataService';
import { useTitle } from '../../hook/useTitle';
import { ServiceCard } from '../../components/Elements/ServiceCard';
import { AllTags } from './components/AllTags';
import 'animate.css';

export const Services = () => {

    const [services, setServices] = useState([]);
    const [uniqueTags, setUniqueTags] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useTitle("Découvrez nos services");

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const data = await getServicesList();
                setServices(data);
                setUniqueTags(getUniqueTags(data));
            } catch (err) {
                setError('Une erreur est survenue lors du chargement de la page.')
            } finally {
                setLoading(false);
            }
        };
        fetchServices();
    }, [])

    const getUniqueTags = (services) => {
        const allTags = services.flatMap(service => service.tags || []);
        return [...new Set(allTags)];
    };

    if (loading) {
        return (
            <span className="loading loading-spinner text-secondary"></span>
        )
    }

    if (error) {
        return (
            <div>{error}</div>
        )
    }

    if (services.length === 0) {
        return <div>Aucun service disponible</div>;
    }

    return (
        <section id="services" className='services animate__animated animate__slideInUp animate_delay-2s'>
            <main>
                <h2 className='font-bold text-4xl text-accent mb-3 ml-2 py-8'><b>Nos</b> <i>services</i></h2>
                <article className='mb-3 ml-2'>
                    <div className='carousel w-full gap-2'>
                        {services.map(service => (
                            <ServiceCard key={service.id} service={service} />
                        ))}
                    </div>
                </article>
                <article className="flex flex-wrap gap-2 py-8 justify-center">
                    <button className="btn btn-primary rounded-full no-animation">TOUS</button>
                    {uniqueTags.map((tag, index) => (
                        <AllTags key={index} tag={tag} />
                    ))}
                </article>
            </main>
        </section>
    )
}

export default Services;